import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { XCircle, AlertCircle } from 'lucide-react';
export function Problem() {
  return <Section bg="bg-white" data-id="element-117">
      <div className="space-y-12" data-id="element-118">
        <div data-id="element-119">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-brand-terracotta flex items-center gap-3" data-id="element-120">
            <AlertCircle className="w-8 h-8 flex-shrink-0" data-id="element-121" />
            La realidad que no te deja dormir
          </h3>
          <div className="space-y-4 text-lg md:text-xl text-brand-brown-light leading-relaxed" data-id="element-122">
            <p data-id="element-123">
              Llegar a los 50 o 60 años sin una cuenta de retiro sólida en
              dólares es una carga mental que no te deja dormir. Miras las
              noticias y solo ves "negocios mágicos" hechos por jóvenes de 20
              años que no entienden tu realidad.
            </p>
            <p data-id="element-124">
              Te han dicho que para ganar dinero hoy necesitas ser un experto en
              computación o tener un título universitario americano. Mientras
              tanto, tu cuerpo se cansa en trabajos físicos pesados y el miedo a
              "qué pasará cuando ya no pueda más" crece cada día. La brecha
              tecnológica te hace sentir fuera del juego.
            </p>
          </div>
        </div>

        <div className="bg-brand-sand p-6 md:p-10 rounded-2xl" data-id="element-125">
          <h3 className="text-xl md:text-2xl font-bold mb-6 text-brand-brown" data-id="element-126">
            Por qué lo que has intentado no ha funcionado:
          </h3>
          <ul className="space-y-5" data-id="element-127">
            {['Has buscado empleos tradicionales y te descartan por "exceso de experiencia" (la forma educada de decirte que prefieren a alguien más joven).', 'Has querido ofrecer tus servicios pero no sabes cómo anunciarte en Facebook sin que parezca spam.', 'Te da miedo usar Zelle o CashApp porque has escuchado historias de gente a la que han estafado.', 'Has ignorado las "clases gratis" de internet porque sabes que al final solo quieren venderte un curso de $1,000 que no tiene nada que ver con tu vida.'].map((item, i) => <li key={i} className="flex items-start gap-4 text-lg md:text-xl text-brand-brown-light" data-id="element-128">
                <XCircle className="w-7 h-7 text-brand-terracotta flex-shrink-0 mt-0.5" data-id="element-129" />
                <span data-id="element-130">{item}</span>
              </li>)}
          </ul>
        </div>

        <CTAButton className="mt-12" href="#pricing" data-id="element-131" />
      </div>
    </Section>;
}